import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { BsPlus, BsEyeFill } from "react-icons/bs";
import { CartContext } from "../contexts/CartContext";

const Product = ({ product }) => {
  const { addToCart } = useContext(CartContext);

  // Destructure the product to include slug
  const { id, slug, image, category, title, price } = product;

  return (
    <div className="border rounded-3xl border-[#e4e4e4] h-auto mb-4 relative overflow-hidden group transition">
      <Link to={`/product/${slug}`} className="block">
        {/* Product Image */}
        <div className="w-full h-[300px] flex justify-center items-center">
          <div className="w-[200px] mx-auto flex justify-center items-center">
            <img
              className="max-h-[160px] group-hover:scale-110 transition duration-300"
              src={image}
              alt={title}
            />
          </div>
        </div>
      </Link>
      {/* Category, Title, Price & Buttons */}
      <div className="p-4 flex items-center justify-between">
        <div>
          <div className="text-sm capitalize text-gray-500 mb-1">{category}</div>
          <h2 className="font-semibold mb-1 hover:text-blue-500 hover:underline">
            <Link to={`/product/${slug}`} className="block">
              {title}
            </Link>
          </h2>
          <h2 className="font-semibold mb-3">$ {price}</h2>
        </div>
        {/* Buttons for Adding to Cart and Viewing Details */}
        <div className="flex gap-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <button
            onClick={(e) => {
              e.stopPropagation();
              addToCart(product, id);
            }}
            className="flex justify-center items-center text-white w-12 h-12 bg-black hover:bg-gray-700 transition duration-300"
          >
            <BsPlus className="text-2xl" />
          </button>
          <Link
            to={`/product/${slug}`}
            onClick={(e) => e.stopPropagation()}
            className="w-12 h-12 bg-white flex justify-center items-center text-primary border border-gray-300 hover:border-gray-400 transition duration-300"
          >
            <BsEyeFill />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Product;
